import { render } from "./ThemeHandler.vue?vue&type=template&id=9285b972"
import script from "./ThemeHandler.vue?vue&type=script&lang=js"
export * from "./ThemeHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__